export const UploadModalConstants = {
  FILE_INFO: 'File format .xlsx, Max size 25mb',
  UPLOAD_SUCCESS_ALT: 'success',
  UPLOAD_ERROR_ALT: 'error',
  REMOVE_ALT: 'remove',
  UPLOAD_ALT: 'upload',
  DRAG_OR_CLICK: 'Drag files here or click to upload',
  PROCEED_BUTTON: 'Proceed',
  GO_BACK_BUTTON: 'Go back',
  PERMITTED_FILES: '.xlsx',
  UPLOAD_COMPONENT_NAME: 'uploadLocationModal',
  XLSX_TYPE:
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  MULTIPART_CONTENT_TYPE: 'multipart/form-data',
  INVALID_FILE_FORMAT: ` Invalid file content`,
  DOWNLOAD_ERROR_FILE: 'Download Error File',
  DEFAULT_UPLOAD_SUCCESS: 'Details updated successfully',
  DEFAULT_ERROR_FILENAME: 'error.xlsx',
  FILE: 'file',
  CONTENT_TYPE: 'Content-type',
  POST: 'POST',
};

export const SCOPE_TITLES = {
  SCOPE_1: 'Scope 1',
  SCOPE_2: 'Scope 2',
  SCOPE_3: 'Scope 3',
};
